<template>
<div>
    <table v-if="loaded && balances.length" class="table">
        <tr>
            <th>Client</th>
            <th>Balance ID</th>
            <th>Player ID</th>
            <th>Branch</th>
            <th>Currency</th>
            <th>Real</th>
            <th>Bonus</th>
            <th>Locked</th>
        </tr>
        <tr v-for="balance in balances" :key="balance.id">
            <td>[{{balance.clientId}}] {{getClientName(balance.clientId)}}</td>
            <td>{{balance.id}}</td>
            <td>{{balance.userId}}</td>
            <td>{{balance.branch}}</td>
            <td>{{balance.currency}}</td>
            <td>{{balance.real | currency(balance.currency)}}</td>
            <td>{{balance.bonus | currency(balance.currency)}}</td>
            <td>{{balance.mbkLockedIn | currency(balance.currency)}}</td>
        </tr>
    </table>
    <p v-if="loaded && !balances.length">
        No locked balances
    </p>
</div>
</template>
<script>
import state from '../../state';
import balanceService from '../../services/balance.service';
import clientService from '../../services/client.service';

export default {
    name: 'mbk-locked-deposited',
    data() {
        return {
            loaded: false,
            balances: []
        }
    },
    computed: {
        clients() {
            return state.clients.get();
        }
    },
    async mounted() {
        await clientService.ensure();
        let bal = await balanceService.getMbkLockedBalances();
        this.balances.push(...bal);
        this.loaded = true;
    },
    methods: {
        getClientName(clientId) {
            return this.clients.find(c => c.id == clientId).name;
        }
    }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/mbk/mbk-locked-deposites.vue